import { useRef, useCallback } from 'react';
import { PageView } from 'app/views';
import { usePage } from 'app/hooks';

const setDisplayOption = (name) => {
  const displayOption = window.tracking_data.search_result_display_option
    ? window.tracking_data.search_result_display_option.split(',')
    : [];
  window.tracking_data.search_result_display_option = displayOption
    .concat(name)
    .join(',');
};

const shouldTrack = (isTracked) =>
  typeof window !== 'undefined' && window.tracking_data && !isTracked.current;

export default (name) => {
  const page = usePage();
  const isTracked = useRef(false);

  return useCallback(() => {
    switch (page.status) {
      case PageView.LOADING:
        if (isTracked.current) {
          isTracked.current = false;
        }
        break;
      case PageView.LOADED:
      case PageView.INITIALIZED:
        if (shouldTrack(isTracked)) {
          isTracked.current = true;
          setDisplayOption(name);
        }
        break;
      default:
        break;
    }
  }, [name, page.status]);
};
